<div [formGroup]="form">
<div class="section-container">
    <div class="section-title">
        <mat-icon class="material-symbols-outlined">tune</mat-icon>
        <span>Configurações avançadas</span>
        <div class="section-title-actions ms-auto">
            <button mat-button type="button" class="btn-section" [matBadge]="personalizadasCount" [matBadgeHidden]="personalizadasCount === 0" (click)="personalizar.emit()">
                <mat-icon class="material-symbols-outlined">settings</mat-icon>
                Personalizar fórmulas
            </button>
        </div>
    </div>

    <div class="row g-3">
        <!-- Item compõe o total da nota -->
        <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Item compõe o total da nota fiscal</mat-label>
                <mat-select formControlName="indTot">
                    @for (i of indicadoresComposicaoTotalItem; track i.codigo) {
                    <mat-option [value]="i.codigo">{{ i.descricao }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        <!-- Descontar ICMS desonerado do total -->
        <div class="col-12 col-md-6">
            <span class="indicador-tooltip-wrap" [matTooltip]="tooltipDeduzDeson" [matTooltipDisabled]="!tooltipDeduzDeson">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Descontar ICMS desonerado do total da nota</mat-label>
                    <mat-select formControlName="indDeduzDeson">
                        @for (i of indicadoresDeducaoDesoneracao; track i.codigo) {
                        <mat-option [value]="i.codigo">{{ i.descricao }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </span>
        </div>

        <!-- PIS-ST compõe o total -->
        <div class="col-12 col-md-6">
            <span class="indicador-tooltip-wrap" [matTooltip]="tooltipPisSt" [matTooltipDisabled]="!tooltipPisSt">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>PIS-ST compõe o total da nota</mat-label>
                    <mat-select formControlName="indSomaPisst">
                        @for (i of indicadoresComposicaoTotalPisSt; track i.codigo) {
                        <mat-option [value]="i.codigo">{{ i.descricao }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </span>
        </div>

        <!-- COFINS-ST compõe o total -->
        <div class="col-12 col-md-6">
            <span class="indicador-tooltip-wrap" [matTooltip]="tooltipCofinsSt" [matTooltipDisabled]="!tooltipCofinsSt">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>COFINS-ST compõe o total da nota</mat-label>
                    <mat-select formControlName="indSomaCofinsst">
                        @for (i of indicadoresComposicaoTotalCofinsSt; track i.codigo) {
                        <mat-option [value]="i.codigo">{{ i.descricao }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </span>
        </div>

        <!-- Tipo da operação (veículos novos) -->
        <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Tipo da operação (veículos novos)</mat-label>
                <mat-select formControlName="tipoOperacaoVeiculo">
                    <mat-option [value]="null">— Não se aplica —</mat-option>
                    @for (t of tiposOperacaoVeiculo; track t.codigo) {
                    <mat-option [value]="t.codigo">{{ t.descricao }}</mat-option>
                    }
                </mat-select>
                <mat-icon
                    matSuffix
                    matTooltip="Preencha somente quando a natureza for de venda de veículo novo."
                    matTooltipPosition="above">
                    info_outline
                </mat-icon>
            </mat-form-field>
        </div>

        <!-- Regime especial de tributação do ISSQN -->
        <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Regime especial de tributação (ISSQN)</mat-label>
                <mat-select formControlName="codigoRegimeTributarioIssqn">
                    <mat-option [value]="null">— Selecione —</mat-option>
                    @for (r of regimesEspeciaisIssqn; track r.codigo) {
                    <mat-option [value]="r.codigo">{{ r.codigo }} – {{ r.descricao }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    </div>
</div>
</div>
